//reduce bundle size by importing required icons only
import { faCopy, faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import aboutIcon from './icons/aboutIcon';
import billingIcon from './icons/billingIcon';
import checkIcon from './icons/checkIcon';
import checkIconActive from './icons/checkIconActive';
import directionIcon from './icons/directionIcon';
import docsIcon from './icons/docsIcon';
import downloadIcon from './icons/downloadIcon';
import exploreIcon from './icons/exploreIcon';
import graterSignIcon from './icons/graterSignIcon';
import growthPlanIcon from './icons/growthPlanIcon';
import homeIcon from './icons/homeIcon';
import lessSignIcon from './icons/lessSignIcon';
import logoIcon from './icons/logoIcon';
import masksIcon from './icons/masksIcon';
import quarantineIcon from './icons/quarantineIcon';
import requestsIcon from './icons/requestsIcon';
import rightArrowIcon from './icons/rightArrowIcon';
import scalePlanIcon from './icons/scalePlanIcon';
import searchIcon from './icons/searchIcon';
import settingsIcon from './icons/settingsIcon';
import signOutIcon from './icons/signOutIcon';
import startUpPlanIcon from './icons/startUpPlanIcon';
import successIcon from './icons/successIcon';
import supportIcon from './icons/supportIcon';
import testsIcon from './icons/testsIcon';
import tripsIcon from './icons/tripsIcon';
import userIcon from './icons/userIcon';



const unknownIcon = faQuestionCircle;

let map = {
  loading: faSpinner,
  copy: faCopy
};

const AppIcon = props => {
  let IconSvg: any = null;

  //switch for svg icons
  switch (props.name) {
    case 'home':
      IconSvg = homeIcon;
      break;
    case 'explore':
      IconSvg = exploreIcon;
      break;
    case 'billing':
      IconSvg = billingIcon;
      break;
    case 'support':
      IconSvg = supportIcon;
      break;
    case 'docs':
      IconSvg = docsIcon;
      break;
    case 'about':
      IconSvg = aboutIcon;
      break;
    case 'sign-out':
      IconSvg = signOutIcon;
      break;
    case 'settings':
      IconSvg = settingsIcon;
      break;
    case 'requests':
      IconSvg = requestsIcon;
      break;
    case 'user':
      IconSvg = userIcon;
      break;
    case 'right-arrow':
      IconSvg = rightArrowIcon;
      break;
    case 'grater':
      IconSvg = graterSignIcon;
      break;
    case 'start-up':
      IconSvg = startUpPlanIcon;
      break;
    case 'growth':
      IconSvg = growthPlanIcon;
      break;
    case 'scale':
      IconSvg = scalePlanIcon;
      break;
    case 'check':
      IconSvg = checkIcon;
      break;
    case 'check-active':
      IconSvg = checkIconActive;
      break;
    case 'download':
      IconSvg = downloadIcon;
      break;
    case 'less':
      IconSvg = lessSignIcon;
      break;
    case 'search':
      IconSvg = searchIcon;
      break;
    case 'direction':
      IconSvg = directionIcon;
      break;
    case 'success':
      IconSvg = successIcon;
      break;
    case 'logo':
      IconSvg = logoIcon;
      break;
    case 'masks':
      IconSvg = masksIcon;
      break;
    case 'quarantine':
      IconSvg = quarantineIcon;
      break;
    case 'tests':
      IconSvg = testsIcon;
      break;
    case 'trips':
      IconSvg = tripsIcon;
      break;

    default:
      break;
  }

  if (IconSvg) {
    let svgProps = {};

    let addPropIfPresent = propName => {
      let value = props[propName];

      if (value) {
        svgProps[propName] = propName === 'width' || propName === 'height' ? `${value / 10}rem` : value;
      }
    };

    addPropIfPresent('width');
    addPropIfPresent('height');
    addPropIfPresent('className');
    addPropIfPresent('color');
    addPropIfPresent('disabled');

    return <IconSvg {...svgProps} />;
  }

  let icon = unknownIcon;

  if (map[props.name]) {
    icon = map[props.name];
  }

  return <FontAwesomeIcon {...props} icon={icon} />;
};

export default AppIcon;
